import { combineReducers } from "redux";
import pasaStore from "./journey";

const rootReducer = combineReducers({
  pasaStore
});

export default rootReducer;
